import type { MemberDto } from "@ied/shared-types";
import { useMutation } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

export function useCreateMember() {
	return useMutation({
		mutationKey: ["members"],
		mutationFn: async (
			body: Pick<
				MemberDto,
				"first_name" | "last_name" | "email" | "phone" | "groups"
			>,
		) => {
			const response = await fetch(`${SERVICE_API}/api/members`, {
				method: "POST",
				credentials: "include",
				body: JSON.stringify({ ...body, is_active: true }),
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (!response.ok) {
				throw new Error("Failed to create member");
			}

			return response;
		},
		onSuccess: (_, __, ___, c) => {
			c.client.invalidateQueries({
				queryKey: ["members"],
			});
		},
	});
}
